import { type ReactNode } from 'react';
import * as React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

const Wrapper = styled.div`
  align-items: flex-start;
  border: 1px solid ${({ theme }) => rgba(theme.highlightColor, 0.15)};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: 10px;
  position: relative;
  text-align: left;
  transition:
    border ${({ theme }) => theme.animation.DURATION}
      ${({ theme }) => theme.animation.EASING},
    background-color ${({ theme }) => theme.animation.DURATION}
      ${({ theme }) => theme.animation.EASING};

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    right: -1px;
    background: ${({ theme }) => rgba(theme.highlightColor, 0.4)};
  }

  &::before {
    width: 20px;
    height: 1px;
  }

  &::after {
    height: 20px;
    width: 1px;
  }

  @media (hover: hover) {
    &:hover {
      border: 1px solid ${({ theme }) => rgba(theme.highlightColor, 0.3)};
      background-color: ${({ theme }) => rgba(theme.highlightColor, 0.1)};
    }
  }
`;

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card: React.ComponentType<CardProps> = React.memo(
  ({ children, className, onClick }) => {
    return (
      <Wrapper className={className} onClick={onClick}>
        {children}
      </Wrapper>
    );
  }
);
